// src/components/Team.js
import React from 'react';
import './Team.css';

function Team() {
  return (
    <section className="team" id="team">
      <div className="team-container">
        <h2>MEET THE TEAM</h2>
        <p className="team-subtitle">The faces, minds, and hearts behind E2e tech</p>
        
        <div className="team-grid">
          <div className="team-member">
            <div className="team-card purple">
              <img src="/images/carolina.jpg" alt="Carolina Bockmeulen" className="team-photo" />
            </div>
            <h3>CAROLINA BOCKMEULEN</h3>
          </div>
          
          <div className="team-member">
            <div className="team-card white">
              <img src="/images/samuel.jpg" alt="Samuel Lederman" className="team-photo" />
            </div>
            <h3>SAMUEL LEDERMAN</h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;

